import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual } from "lodash";


import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';

import {cloneObject, getParam} from '../utils/utils';

import dsd from "../classes/clsDSD";
import {getRevision, addRevision, editRevision, deleteRevision} from '../utils/utilsRevision';

import { Trash } from 'react-bootstrap-icons';

class Revision extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            isFailed: false
        };


        this.data = {};

        this.handleChange = this.handleChange.bind(this);
        this.handleButton = this.handleButton.bind(this);


        this.dsd = new dsd();

        this.FallBackNavigation = `.`;


    }

    componentDidMount(){

       this.setup();

    }

    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

        let StateChange = {};

        if (!isEqual(this.state, prevState)){

            if (this.state.loadRevision){
                this.loadRevision();
            }
    
            if (this.state.isLoaded) {
                if (this.state.Revision){
                    StateChange.FormData = this.state.Revision;
                }
            }

            this.setState(StateChange);

        }

    }
    
    setup(){

        let StateChange = {

            loadRevision: false,
            isLoaded:false,

            FormData: {
                report:false
            },

            Revision: null,
            idRevision: null,

            idAbout: null,

            mode: null

        }

        StateChange.idAbout = getParam('idAbout', this.props);
        if (StateChange.idAbout){
            StateChange.mode = 'new';
            StateChange.isLoaded = true;
        }

        StateChange.idRevision = getParam('idRevision', this.props);
        if (StateChange.idRevision){
            StateChange.mode = 'edit';
        }


        if (StateChange.idRevision){
            StateChange.loadRevision = true;
        }

        this.setState(StateChange);
        
    }


    loadRevision(){

        let StateChange = {};
        StateChange.loadRevision = false;
        StateChange.isLoaded = false;
        StateChange.Revision = null;

        if (this.state.idRevision){
            StateChange.renderState = "loading";
            this.setState(StateChange);

            const onLoad = (Revision) => {
                this.setState({
                    Revision,
                    isLoaded: true,
                    renderState: "loaded"
                });
            };

            const onFail = (error) => {
                this.setState({
                    isFailed: true,
                    renderState: "failed"
                });
                console.error('Failed to load revision:', error);
            };

            getRevision(this.dsd, this.state.idRevision, onLoad, onFail);
        } else {
            this.setState(StateChange);
        }

        return;
        
    };

    handleButton(event) {
    
        let StateChange = {};

        switch (event.currentTarget.name){
            case 'btnDelete':
                const onDeleteSuccess = () => {
                    this.setState({
                        isUpdated: true
                    });
                };
                const onDeleteError = (error) => {
                    this.setState({
                        isFailed: true,
                        errorMessage: error.message
                    });
                };
                deleteRevision(this.dsd, this.state.idRevision, onDeleteSuccess, onDeleteError);
                break;
    
        }
    
        this.setState(StateChange);
    
        event.preventDefault();    

    };


    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let FormData = this.state.FormData;
        FormData[FormFieldName] = FormFieldValue;

        this.setState({"FormData": FormData});

    };

    update(){    

        if (!this.state.isLoaded){
            return false;
        }

        const onSuccess = (idRevision) => {
            this.setState({
                isUpdated: true,
                idRevision: idRevision || this.state.idRevision
            });
        };

        const onError = (error) => {
            this.setState({
                isError: true,
                errorMessage: error.message
            });
        };

        switch (this.state.mode){
            case 'new':
                addRevision(this.dsd, this.state.idAbout, this.state.FormData, onSuccess, onError);
                break;
            case 'edit':
                editRevision(this.dsd, this.state.idRevision, this.state.FormData, onSuccess, onError);
                break;
            default:
                return false;
        };

        return true;

    }



    render() {

        if (this.state.isFailed) {
            return <PD.ErrorBox>ERROR - Failed to Load</PD.ErrorBox>
        }


        if (this.state.isLoaded) {

            switch (this.state.mode){
                case 'new':
                case 'edit':

                    return (
                        <fieldset>
                            <legend>Revision:</legend>
                            <PD.Editor label='Description' name="description" value={this.state.FormData.description} onChange={this.handleChange}/>
                            <PD.Checkbox label="Report?" name="report" value={this.state.FormData.report} onChange={this.handleChange}/>
                        </fieldset>
                    );
                    break;
            };
        };

        return null;
    };
};

// Wrap and export
// with forwardref so that the update() method can be accessed.


export default React.forwardRef((props, ref) => {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Revision ref={ref} {...props} navigation={navigation} location={location} params={params} />;
  }
);